import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { TopNavbarComponent } from './components/top-navbar/top-navbar.component';


@NgModule({
    declarations: [
        TopNavbarComponent,
        SideNavbarComponent,
    ],
    imports: [
        RouterModule,
        SharedModule
    ],
    exports: [
        TopNavbarComponent,
        SideNavbarComponent,
    ]
})
export class MainModule { }
